<template>
  <span>
    <div class="ui primary basic button" @click="showModal"
         :class="{ 'right floated': isRightFloated }" >
      <i class="add icon"></i>
      <span v-if="type === 'lesson'"> New Lesson Plan</span>
      <span v-if="type === 'action'"> New Action Plan</span>
    </div>
    <div class="ui basic mini modal" :id="modalId">
      <div class="header" v-if="type === 'lesson'">Create New Lesson Plan</div>
      <div class="header" v-if="type === 'action'">Create New Action Plan</div>
      <div class="content">
        <div class="ui form" :id="formId">
          <div class="field">
            <div class="ui labeled fluid input">
              <div class="ui label">
                Name
              </div>
              <input name="title" type="text" placeholder="Keep it short and simple" v-model="templateTitle">
            </div>
          </div>
        </div>
        <br>
        <p><i>The new plan will be visible to all nurses in this program.</i></p>
      </div>
      <div class="actions">
        <div class="ui left floated button" @click.prevent="resetValue">Cancel</div>
        <div class="ui button" @click.prevent="postPlan">Save</div>
      </div>
    </div>
  </span>
</template>

<script>

  export default {
	  props: {
      isRightFloated: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        required: true
      }
    },
		data() {
			return {
			  templateTitle: null,
        modalId: 'plan-template-' + this._uid,
        formId: 'plan-template-form-' + this._uid
      }
		},
		computed: {
      planObject(){
        return {
          planType: this.type,
          attribute: 'NVSDemoCoaching',
          programId: process.env.PROGRAM_ID,
          data: {
            title: this.templateTitle,
            deletedStatus: false,
            childPlans: []
          }
        }
      },
    },
		methods: {
	    initFormValidation: function(){
	      //Note: using regex to polyfill for the trim function so that it will work on old browsers too
        $.fn.form.settings.rules.whitespaces = () => {
            return (this.templateTitle.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '') !== '');
        };

        $('#' + this.formId).form({
          fields: {
            'title': {
              identifier: 'title',
              rules: [
                {type: 'empty', prompt: 'Plan Title cannot be empty'},
                {type: 'whitespaces', prompt: 'Please enter a name for the Plan Title'}
              ]
            }
          },
          inline: true
        });

      },
      resetValue: function(){
        this.templateTitle = null;
        $('#' + this.modalId).modal('hide');
      },
		  showModal: function(){
        this.templateTitle = null;
        $('#' + this.modalId).modal({closable: false}).modal('show');
      },
      postPlan: function() {
        let validationStatus = $('#' + this.formId).form('validate form');
        if (validationStatus === true) {
          let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlanTemplate';
          this.$http.post(requestUrl, this.planObject).then( (response) => {
            this.getProgramPlans().then(()=>{
              this.resetValue();
            })
          });
        }
        else {
          $('#' + this.formId).form('validate form');
        }

      }
    },
		mounted() {
      this.initFormValidation();
		},
		beforeDestroy(){
      let modal = document.querySelector('#' + this.modalId);
      if (modal !== null) {
        modal.remove();
      }
    }
	}
</script>

<style>
  .dimmable,  .dimmed, .dimmer {
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/content/PlanTemplateCreate.vue